import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";

import { calendar, calendarOutline, close, closeOutline } from "ionicons/icons";
import { DialogoConfirmacion } from "../../components/basicsComponents/DialogoConfirmacion/DialogoConfirmacion";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import {
  convertToPlain,
  obtenerNombreDia,
} from "../../utils/funcionalidadesStrings";
import ComprobanteTurno from "../../components/formComponents/ComprobanteTurno/ComprobanteTurno";
import {
  Column,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import { Button, Card, Option, Select, Typography } from "@mui/joy";
import useTituloPagina from "../../hooks/tituloPagina";
import { DIRECCION_ATENCION } from "../../utils/direccionAtencion";
import {
  esTurnoDelDia,
  MENSAJE_CANCELACION_MISMO_DIA,
} from "../../utils/restriccionCancelacionTurno";

export default function TurnosPaciente() {
  const colorTextoPrincipal = "var(--portal-text-primary)";
  const colorAcento = "var(--portal-accent)";
  const colorAcentoOscuro = "var(--portal-accent-shade)";
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [urlAxioPP, setUrlAxio] = useState("");
  const [tituloPagina, setTituloPagina] = useState("");
  const [servicios, setServicios] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [sedeSeleccionada, setSedeSeleccionada] = useState(-1);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [filtroCancelados, setFiltroCancelados] = useState(-1);
  const [filtroAsistidos, setFiltroAsistidos] = useState(-1);
  const [listadoTurnos, setListadoTurnos] = useState([]);
  const [listadoTurnosFiltrados, setListadoTurnosFiltrados] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [openReagendar, setOpenReagendar] = useState(true);
  const [turnoReagendar, setTurnoReagendar] = useState(null);
  const [abrirModalCancelarReserva, setAbrirModalCancelarReserva] =
    useState(false);
  const [abrirDesplegableAsistidos, setAbrirDeplegableAsistidos] =
    useState(false);
  const [abrirDesplegableCancelados, setAbrirDeplegableCancelados] =
    useState(false);
  const [abrirComprobanteTurno, setAbrirComprobanteTurno] = useState(false);
  const [cancelados, setCancelados] = useState([
    { codigo: true, text: "Cancelados" },
    { codigo: false, text: "No cancelados" },
  ]);
  const [asistidos, setAsistidos] = useState([
    { codigo: false, text: "No asistidos" },
    { codigo: true, text: "Asistidos" },
  ]);
  const [estadoTurnosFiltrados, setEstadoTurnosFiltrados] = useState(-1);
  const [expandedAcordeons, setExpandedAcordeons] = useState(new Set());

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const traerTurnosPaciente = async (paciente) => {
    let turnos = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      // Traer turnos activos
      const response = await axios.get(
        `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}`,
        config,
      );
      if (response.data.length !== 0) {
        turnos = response.data;
      }
      console.log(turnos);
      // Traer también los turnos cancelados (siempre, independientemente de si hay activos)
      const response2 = await axios.get(
        `${url}Turnos/TurnosPaciente/?paciente=${paciente.codigo}&Cancelado=true`,
        config,
      );
      if (response2.data.length !== 0) {
        turnos = turnos.concat(response2.data);
      }
      // Si no hay turnos activos ni cancelados, entonces turnos será null
      setListadoTurnos(turnos.length > 0 ? turnos : null);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar sus turnos registrados",
        "rojo",
      );
    }
  };
  const traerEspecialidades = async (paciente, prestadoresDisponibles) => {
    let especialidades = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Especialidades`, config);
      if (response.data.length !== 0) {
        especialidades = response.data;
      } else {
        especialidades = null;
      }

      especialidades = especialidades.filter(
        (especialidad) => especialidad.vigente === true,
      );

      //Obtenemos especialidades de los prestadores
      const especialidadesMostrables = [];
      prestadoresDisponibles.forEach((prestador) => {
        const valor = prestador.especialidad;
        if (!especialidadesMostrables.includes(valor)) {
          especialidadesMostrables.push(valor);
        }
      });
      //Buscamos especialidades de los prestadores entre todas las mutuales vigentes
      const especialidadesCoincidentes = [];
      especialidades.forEach((especialidad) => {
        if (especialidadesMostrables.includes(especialidad.codigo)) {
          especialidadesCoincidentes.push(especialidad);
        }
      });
      //Asignamos especialidades resultantes
      especialidades = especialidadesCoincidentes;

      especialidades = especialidades.map((especialidad) => {
        return {
          ...especialidad,
          text: especialidad.nombre,
        };
      });

      setEspecialidades(especialidades);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar las especialidades registradas",
        "rojo",
      );
    }
  };

  const traerPrestadores = async (paciente) => {
    let prestadores = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}Prestadores?mutuales=${paciente.mutual}`,
        config,
      );
      if (response.data.length !== 0) {
        prestadores = response.data;
      } else {
        prestadores = null;
      }

      prestadores = prestadores.filter(
        (prestador) => prestador.vigente === true,
      );

      prestadores = prestadores.map((prestador) => {
        return {
          ...prestador,
          text: prestador.nombre,
          note2: DIRECCION_ATENCION,
        };
      });
      return prestadores;
      setPrestadores(prestadores);
      setListadoPrestadores(prestadores);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar consultar los/las prestadores/as registradas",
        "rojo",
      );
    }
  };

  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(`${url}Estudios`, config);
      if (response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar l registradas en el sistema",
        "rojo",
      );
    }
  };

  const TraerServicio = async (paciente) => {
    try {
      let servicioResponse = {};
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${paciente.token}` },
      };
      servicioResponse = await axios
        .get(`${url}Servicios`, config)
        .then((response) => {
          if (response.data.length !== 0) {
            return response.data;
          }
        });
      setServicios(servicioResponse);
    } catch (e) {}
  };

  const CargarDesplegables = async (sesion) => {
    await traerTurnosPaciente(sesion);
    let prestadoresDisponibles = await traerPrestadores(sesion);
    await traerEspecialidades(sesion, prestadoresDisponibles);
    await traerEstudios(sesion);
    await TraerServicio(sesion);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        CargarDesplegables(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const handleChangeSelect = (value, select) => {
    let especialidadSegunSede = -1;
    let edad = dayjs(dayjs()).diff(usuario.nacimiento, "year");

    switch (select) {
      case "Sede":
        switch (value) {
          case 1:
            if (edad < 17) {
              especialidadSegunSede = 107;
            } else {
              especialidadSegunSede = 98;
            }
            break;
          case 2:
            if (edad < 17) {
              especialidadSegunSede = 108;
            } else {
              especialidadSegunSede = 105;
            }
            break;
          case 3:
            if (edad < 17) {
              especialidadSegunSede = 109;
            } else {
              especialidadSegunSede = 106;
            }
            break;
          default:
            mostrarNotificacion(true, "Seleccion invalida", "rojo");
            break;
        }

        if (especialidadSegunSede !== -1) {
          setListadoPrestadores(
            prestadores.filter(
              (prestador) =>
                prestador.especialidad === especialidadSegunSede ||
                prestador.especialidad2 === especialidadSegunSede ||
                prestador.especialidad3 === especialidadSegunSede,
            ),
          );
        } else {
          setListadoPrestadores(prestadores);
        }
        setPrestadorSeleccionado(-1);
        setSedeSeleccionada(value);
        setEspecialidadSeleccionada(especialidadSegunSede);
        break;
      case "Especialidad":
        if (value !== -1) {
          switch (value) {
            case 98:
            case 107:
              especialidadSegunSede = 1;
              break;
            case 105:
            case 108:
              especialidadSegunSede = 2;
              break;
            case 106:
            case 109:
              especialidadSegunSede = 3;
              break;
            default:
              mostrarNotificacion(true, "Seleccion invalida", "rojo");
              break;
          }
          setListadoPrestadores(
            prestadores.filter((prestador) => prestador.especialidad === value),
          );
        } else {
          setListadoPrestadores(prestadores);
        }
        setPrestadorSeleccionado(-1);
        setSedeSeleccionada(especialidadSegunSede);
        setEspecialidadSeleccionada(value);
        break;
      case "Prestador":
        prestadores.map((prestador) => {
          if (prestador.codigo === value) {
            handleChangeSelect(prestador.especialidad, "Especialidad");
          }
        });
        setPrestadorSeleccionado(value);
        break;
      case "Cancelados":
        setFiltroCancelados(value);
        break;
      case "Asistidos":
        setFiltroAsistidos(value);
        break;
      default:
        mostrarNotificacion(true, "Seleccion invalida", "rojo");
        break;
    }
  };

  const CancelarTurno = async () => {
    try {
      if (!turnoSeleccionado?.codigo) {
        mostrarNotificacion(true, "No se encontró el turno a cancelar", "rojo");
        return false;
      }

      if (esTurnoDelDia(turnoSeleccionado.fecha)) {
        mostrarNotificacion(true, MENSAJE_CANCELACION_MISMO_DIA, "rojo");
        return false;
      }

      const config = {
        headers: { Authorization: `Bearer ${usuario.token}` },
      };

      const cancelarTurnoResponse = await axios.patch(
        `${urlAxioPP}Turnos/Cancelar/${turnoSeleccionado.codigo}`,
        "",
        config,
      );
      const quitarTurnoResponse = await axios.patch(
        `${urlAxioPP}Turnos/Quitar/${turnoSeleccionado.codigo}`,
        "",
        config,
      );

      const cancelacionExitosa =
        cancelarTurnoResponse.status >= 200 &&
        cancelarTurnoResponse.status < 300 &&
        quitarTurnoResponse.status >= 200 &&
        quitarTurnoResponse.status < 300;

      if (cancelacionExitosa) {
        mostrarNotificacion(true, "El turno se cancelo correctamente", "verde");
        return true;
      }

      mostrarNotificacion(
        true,
        "Ocurrió un problema al intentar cancelar el turno",
        "rojo",
      );
      return false;
    } catch (error) {
      const mensajeError =
        error?.response?.data?.message ||
        error?.response?.data ||
        error.message ||
        "Ocurrió un problema al intentar cancelar el turno";
      mostrarNotificacion(true, "Error: " + mensajeError, "rojo");
      return false;
    }
  };

  const FiltrarTurnos = () => {
    let listado = listadoTurnos || [];

    if (listado.length > 0) {
      if (especialidadSeleccionada !== -1) {
        listado = listado.filter(
          (turno) => especialidadSeleccionada === turno.especialidad,
        );
      }
      if (prestadorSeleccionado !== -1) {
        listado = listado.filter(
          (turno) => prestadorSeleccionado === turno.prestadorCod,
        );
      }
      if (filtroAsistidos !== -1) {
        listado = listado.filter((turno) => filtroAsistidos === turno.asistio);
      }
      if (filtroCancelados === true) {
        listado = listado.filter(
          (turno) => turno.aCancelar === false && turno.asistio === false,
        );
      } else if (filtroCancelados === false) {
        listado = listado.filter(
          (turno) =>
            turno.aCancelar === true ||
            (turno.aCancelar === false && turno.asistio === true),
        );
      }

      switch (estadoTurnosFiltrados) {
        case 0:
          listado = listado.filter((turno) => turno.asistio === true);
          break;
        case 1:
          listado = listado.filter(
            (turno) => turno.aCancelar === false && turno.asistio === false,
          );
          break;
        case 2:
          listado = listado.filter(
            (turno) => turno.aCancelar === true && turno.asistio === false,
          );
          break;
        default:
          break;
      }
    }

    setListadoTurnosFiltrados(listado);
  };

  useEffect(() => {
    FiltrarTurnos();
  }, [listadoTurnos, estadoTurnosFiltrados]);

  const togleAbrirCerrarCancelarReserva = () => {
    if (abrirModalCancelarReserva) {
      setTurnoSeleccionado({});
    }
    setAbrirModalCancelarReserva(!abrirModalCancelarReserva);
  };

  const handleClickSeleccionarTurno = (turno) => {
    if (esTurnoDelDia(turno.fecha)) {
      mostrarNotificacion(true, MENSAJE_CANCELACION_MISMO_DIA, "rojo");
      return;
    }
    setTurnoSeleccionado(turno);
    togleAbrirCerrarCancelarReserva();
  };

  const handleClickCancelarReserva = async () => {
    togleAbrirCerrarCancelarReserva();
    setCargando(true);
    const cancelacionExitosa = await CancelarTurno();
    if (cancelacionExitosa) {
      await traerTurnosPaciente(usuario);
    }
    setCargando(false);
  };

  const togleAbrirCerrarComprobanteTurno = () => {
    if (abrirComprobanteTurno) {
      setTurnoSeleccionado({});
    }
    setAbrirComprobanteTurno(!abrirComprobanteTurno);
  };

  const handleClickComprobanteTurno = (turno) => {

    const lugarAtencionFinal = DIRECCION_ATENCION;

    setTurnoSeleccionado({
      codigo: turno.codigo,
      equipoNom: turno.equipoNom,
      especialidadNom: turno.especialidadNom,
      estudioNom: turno.estudioNom,
      fecha: turno.fecha,
      hora: turno.hora,
      mutualNom: turno.mutualNom,
      prestadorNom: turno.prestadorNom,
      servicio: turno.servicio,
      apellido: usuario.apellido,
      nombre: usuario.nombre,
      mutualNombre: usuario.mutualNombre,
      mutualAfiliado: usuario.mutualAfiliado,
      hc: usuario.hc,
      documentoTipoNombre: usuario.documentoTipoNombre,
      documentoNro: usuario.documentoNro,
      celular: usuario.celular,
      email: usuario.email,
      lugarAtencion: lugarAtencionFinal,
      preparacionEstudio:
        /*estudios.find((estudio) => estudio.codigo === turno.estudio)[0]?.preparacion !== ""
          ? convertToPlain(
              estudios.filter((estudio) => estudio.codigo === turno.estudio)[0]?.preparacion
            )
          :*/ null,
    });
    setAbrirComprobanteTurno(true);
  };

  const handleClickReservarTurnoPrestador = (prestador) => {
    history.push({
      pathname: "/portal/Reservar turno",
      state: { prestador: prestador },
    });
  };

  const handleClickVolverInicio = () => {
    history.push({
      pathname: "/portal/Inicio",
    });
  };

  const handleClickReagendarTurno = (turno) => {
    setTurnoReagendar({
      ...turno,
      nombre_profesional: turno.prestadorNom,
      idTramite: turno.codigo,
    });

    setTurnoSeleccionado(turno);
    setOpenReagendar(true);
  };

  const esMismoDiaOPasado = (fecha) =>
    dayjs(fecha).isSame(dayjs(), "day") ||
    dayjs(fecha).isBefore(dayjs(), "day");

  const renderTurnosLista = (seePreviusVersion) => {
    return (
      <IonGrid
        className="tabla"
        style={{
          // border:
          //   "1px solid var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))))",
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        {listadoTurnos.filter(
          (fila) => fila.aCancelar && dayjs(fila.fecha).isAfter(new Date()),
        ).length > 0 && (
          <>
            <IonIcon slot="start" md={calendar} ios={calendarOutline} />
            <Column className="" xs={12} marginBottom={1}>
              <Row>
                <Typography level="body-sm">Próximos turnos</Typography>
              </Row>
            </Column>
          </>
        )}
        {listadoTurnos
          .filter(
            (fila) => fila.aCancelar && dayjs(fila.fecha).isAfter(new Date()),
          )
          .sort((a, b) => new Date(a.hora) - new Date(b.hora))
          .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
          .map((fila) => (
            <Card
              style={{ marginBottom: "7.5px", padding: "0px 14px" }}
              key={fila.codigo}
            >
              <Row
                className=""
                style={{ textAlign: "start" }}
                alignItems="center"
                container
              >
                <Column
                  style={{ textAlign: "start" }}
                  xs={6}
                  md={8}
                  lg={10}
                  container
                >
                  <Row alignItems="center" container>
                    <Column xs={12} md={6}>
                      <Typography
                        level="title-sm"
                        sx={{ color: colorTextoPrincipal }}
                      >
                        {fila.prestadorNom === "EQUIPOS"
                          ? `${fila.estudioNom}`
                          : `${fila.prestadorNom + " - " + fila.especialidadNom}`}
                      </Typography>
                    </Column>
                    <Column xs={12} md={6}>
                      <Typography level="title-sm">
                        {`${obtenerNombreDia(dayjs(fila.fecha).format("dddd"))} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                          fila.fecha,
                        ).format(
                          "MMMM, YYYY",
                        )} a las ${dayjs(fila.hora).format("HH:mm")}`}
                      </Typography>
                    </Column>
                  </Row>
                  <Row className="" alignItems="center" container>
                    <Column xs={12} md={6}>
                      <Typography level="body-sm">{`${fila.mutualNom}`}</Typography>
                    </Column>
                    <Column xs={12} md={6}>
                      <Typography level="body-sm">{`Estado: ${fila.asistio ? "Asistido" : fila.aCancelar ? "Pendiente" : "Cancelado"}`}</Typography>
                    </Column>
                  </Row>
                  <Row className="" alignItems="center" container>
                    <Column xs={12}>
                      <Typography level="body-sm">
                        {fila.prestadorNom === "EQUIPOS" &&
                        estudios.filter(
                          (estudio) => estudio.codigo === fila.estudio,
                        )[0]?.preparacion !== ""
                          ? convertToPlain(
                              estudios.filter(
                                (estudio) => estudio.codigo === fila.estudio,
                              )[0]?.preparacion,
                            )
                          : null}
                      </Typography>
                    </Column>
                  </Row>
                </Column>
                <Column container xs={6} md={4} lg={2}>
                  <Row container>
                    {(dayjs().format("YYYY-MM-DD") !==
                      dayjs(fila.fecha).format("YYYY-MM-DD") ||
                      (dayjs().format("YYYY-MM-DD") ===
                        dayjs(fila.fecha).format("YYYY-MM-DD") &&
                        dayjs(fila.hora).format("HH:mm") >
                          dayjs().format("HH:mm"))) &&
                    fila.aCancelar ? (
                      <Column xs={12} container>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickComprobanteTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              marginRight: "4px",
                              fontSize: "1rem",
                              lineHeight: 1,
                              color: colorTextoPrincipal,
                            }}
                          >
                            🖨️
                          </Typography>
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Comprobante
                          </IonLabel>
                        </IonButton>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickSeleccionarTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <IonIcon
                            aria-label="Cancelar turno"
                            ios={closeOutline}
                            md={close}
                            style={{ color: colorTextoPrincipal }}
                          />
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Cancelar
                          </IonLabel>
                        </IonButton>
                      </Column>
                    ) : (
                      <Column className="" xs={12} container>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickComprobanteTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              marginRight: "4px",
                              fontSize: "1rem",
                              lineHeight: 1,
                              color: colorTextoPrincipal,
                            }}
                          >
                            🖨️
                          </Typography>
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Comprobante
                          </IonLabel>
                        </IonButton>

                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() =>
                            handleClickReservarTurnoPrestador(fila.prestadorCod)
                          }
                          style={{ margin: "0px" }}
                        >
                          <Typography
                            level="title-sm"
                            sx={{ color: colorTextoPrincipal }}
                          >
                            {`Reservar turno`.toUpperCase()}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              marginLeft: "4px",
                              fontSize: "1.35rem",
                              lineHeight: 1,
                              color: colorAcento,
                              fontWeight: 900,
                            }}
                          >
                            +
                          </Typography>
                        </IonButton>
                      </Column>
                    )}
                  </Row>
                </Column>
              </Row>
            </Card>
          ))}
        {listadoTurnos.filter(
          (fila) => !fila.aCancelar || esMismoDiaOPasado(fila.fecha),
        ).length > 0 && (
          <>
            <IonIcon slot="start" md={calendar} ios={calendarOutline} />
            <Column className="" xs={12} marginBottom={1}>
              <Row>
                <Typography level="body-sm" sx={{ fontWeight: 700 }}>
                  Historial de turnos
                </Typography>
              </Row>
            </Column>
          </>
        )}
        {listadoTurnos
          .filter((fila) => !fila.aCancelar || esMismoDiaOPasado(fila.fecha))
          .sort((a, b) => new Date(b.hora) - new Date(a.hora))
          .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
          .map((fila) => (
            <Card
              style={{ marginBottom: "7.5px", padding: "0px 14px" }}
              key={fila.codigo}
            >
              <Row
                className=""
                style={{ textAlign: "start" }}
                alignItems="center"
                container
              >
                <Column
                  style={{ textAlign: "start" }}
                  xs={6}
                  md={8}
                  lg={10}
                  container
                >
                  <Row alignItems="center" container>
                    <Column xs={12} md={6}>
                      <Typography
                        level="title-sm"
                        sx={{ color: colorTextoPrincipal }}
                      >
                        {fila.prestadorNom === "EQUIPOS"
                          ? `${fila.estudioNom}`
                          : `${fila.prestadorNom + " - " + fila.especialidadNom}`}
                      </Typography>
                    </Column>
                    <Column xs={12} md={6}>
                      <Typography level="title-sm">
                        {`${obtenerNombreDia(dayjs(fila.fecha).format("dddd"))} ${dayjs(fila.fecha).format("DD")} de ${dayjs(
                          fila.fecha,
                        ).format(
                          "MMMM, YYYY",
                        )} a las ${dayjs(fila.hora).format("HH:mm")}`}
                      </Typography>
                    </Column>
                  </Row>
                  <Row className="" alignItems="center" container>
                    <Column xs={12} md={6}>
                      <Typography level="body-sm">{`${fila.mutualNom}`}</Typography>
                    </Column>
                    <Column xs={12} md={6}>
                      <Typography level="body-sm">{`Estado: ${
                        fila.asistio
                          ? "Asistido"
                          : fila.aCancelar && fila.codigo !== 0
                            ? "Inasistido"
                            : "Cancelado"
                      }`}</Typography>
                    </Column>
                  </Row>
                  <Row className="" alignItems="center" container>
                    <Column xs={12}>
                      <Typography level="body-sm">
                        {fila.prestadorNom === "EQUIPOS" &&
                        estudios.filter(
                          (estudio) => estudio.codigo === fila.estudio,
                        )[0]?.preparacion !== ""
                          ? convertToPlain(
                              estudios.filter(
                                (estudio) => estudio.codigo === fila.estudio,
                              )[0]?.preparacion,
                            )
                          : null}
                      </Typography>
                    </Column>
                  </Row>
                </Column>
                <Column container xs={6} md={4} lg={2}>
                  <Row container>
                    {(dayjs().format("YYYY-MM-DD") !==
                      dayjs(fila.fecha).format("YYYY-MM-DD") ||
                      (dayjs().format("YYYY-MM-DD") ===
                        dayjs(fila.fecha).format("YYYY-MM-DD") &&
                        dayjs(fila.hora).format("HH:mm") >
                          dayjs().format("HH:mm"))) &&
                    fila.aCancelar ? (
                      <Column xs={12} container>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickComprobanteTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              marginRight: "4px",
                              fontSize: "1rem",
                              lineHeight: 1,
                              color: colorTextoPrincipal,
                            }}
                          >
                            🖨️
                          </Typography>
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Comprobante
                          </IonLabel>
                        </IonButton>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickSeleccionarTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <IonIcon
                            aria-label="Cancelar turno"
                            ios={closeOutline}
                            md={close}
                            style={{ color: colorTextoPrincipal }}
                          />
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Cancelar
                          </IonLabel>
                        </IonButton>
                      </Column>
                    ) : (
                      <Column className="" xs={12} container>
                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() => handleClickComprobanteTurno(fila)}
                          style={{ margin: "0px" }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              marginRight: "4px",
                              fontSize: "1rem",
                              lineHeight: 1,
                              color: colorTextoPrincipal,
                            }}
                          >
                            🖨️
                          </Typography>
                          <IonLabel style={{ color: colorTextoPrincipal }}>
                            Comprobante
                          </IonLabel>
                        </IonButton>

                        <IonButton
                          shape="roud"
                          fill="clear"
                          onClick={() =>
                            handleClickReservarTurnoPrestador(fila.prestadorCod)
                          }
                          style={{ margin: "0px" }}
                        >
                          <Typography
                            level="title-sm"
                            sx={{ color: colorTextoPrincipal }}
                          >
                            {`Reservar turno`.toUpperCase()}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              marginLeft: "4px",
                              fontSize: "1.35rem",
                              lineHeight: 1,
                              color: colorAcento,
                              fontWeight: 900,
                            }}
                          >
                            +
                          </Typography>
                        </IonButton>
                      </Column>
                    )}
                  </Row>
                </Column>
              </Row>
            </Card>
          ))}
      </IonGrid>
    );
  };

  return (
    <>
      <Button
        size="sm"
        onClick={handleClickVolverInicio}
        sx={{
          position: "fixed",
          top: "calc(env(safe-area-inset-top, 0px) + 74px)",
          right: "max(44px, calc(env(safe-area-inset-right, 0px) + 26px))",
          zIndex: 1200,
          borderRadius: "999px",
          backgroundColor: colorAcento,
          color: "#FFFFFF",
          fontWeight: 700,
          boxShadow: "0 10px 22px rgba(var(--portal-accent-rgb), 0.28)",
          px: 1.5,
          "&:hover": {
            backgroundColor: colorAcentoOscuro,
          },
        }}
      >
        ⬅️ Volver
      </Button>
      {listadoTurnos === null || listadoTurnos.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene turnos registrados</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          <div style={{ paddingTop: "34px" }}>{renderTurnosLista()}</div>

          <DialogoConfirmacion
            titulo="Cancelar turno"
            texto={`Ha decidido cancelar el turno con el/la profecional ${turnoSeleccionado.prestadorNom}, con especialidad en ${
              turnoSeleccionado.especialidadNom
            }, para el dia ${obtenerNombreDia(dayjs().format("dddd"))} ${dayjs().format("DD")} de ${dayjs().format(
              "MMMM, YYYY",
            )} a las ${dayjs().format("HH:mm")}, ¿Esta seguro/a de ello?`}
            open={abrirModalCancelarReserva}
            setOpen={setAbrirModalCancelarReserva}
            handleClickConfirmar={handleClickCancelarReserva}
            colorBotonNo="danger"
            colorBotonSi="success"
            textoBotonNo="No"
            textoBotonSi="Si, cancelo"
          />

          <ComprobanteTurno
            turno={turnoSeleccionado}
            abrir={abrirComprobanteTurno}
            togleAbrirCerrarComprobanteTurno={togleAbrirCerrarComprobanteTurno}
            paciente={usuario}
          />
          <CustomToast
            openToast={toast.open}
            onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
            message={toast.mensaje}
            colorNotificacion={toast.tipo}
            duration={toast.mensaje === MENSAJE_CANCELACION_MISMO_DIA ? 10000 : 5000}
          />
        </>
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
